import { createSlice } from "@reduxjs/toolkit";
import {
  fetchProjectStatuses,
  getProjectIdFromFetchStatusesArg,
} from "../Thunks/projectStatusesThunk";
import { SUPERSEDED_REQUEST } from "../helpers/asyncResource";

const initialState = {
  dataByProjectId: {},
  loadingByProjectId: {},
  errorByProjectId: {},
};

export const projectStatusesSlice = createSlice({
  name: "projectStatuses",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectStatuses.pending, (state, action) => {
        const projectId = getProjectIdFromFetchStatusesArg(action.meta.arg);
        state.loadingByProjectId[projectId] = true;
        state.errorByProjectId[projectId] = null;
      })
      .addCase(fetchProjectStatuses.fulfilled, (state, action) => {
        const projectId = getProjectIdFromFetchStatusesArg(action.meta.arg);
        state.loadingByProjectId[projectId] = false;
        state.errorByProjectId[projectId] = null;
        // API response is always: { success: true, data: [...] }
        state.dataByProjectId[projectId] = action.payload;
      })
      .addCase(fetchProjectStatuses.rejected, (state, action) => {
        const projectId = getProjectIdFromFetchStatusesArg(action.meta.arg);
        if (action.payload === SUPERSEDED_REQUEST) return;
        state.loadingByProjectId[projectId] = false;
        state.errorByProjectId[projectId] =
          action.payload ?? action.error?.message ?? "Something went wrong";
      });
  },
});

export const selectProjectStatusesResponse = (state, projectId) =>
  state.projectStatuses?.dataByProjectId?.[projectId] ?? null;

export const selectProjectStatusesLoading = (state, projectId) =>
  !!state.projectStatuses?.loadingByProjectId?.[projectId];

export const selectProjectStatusesError = (state, projectId) =>
  state.projectStatuses?.errorByProjectId?.[projectId] ?? null;

export default projectStatusesSlice.reducer;
